<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">

    <v-row>
      <v-col cols="3">
      </v-col>
      <v-col cols="6">
        <CollapsibleComponent
          @edit="onEdit" @save="onSave" @discard="onDiscard"
          :slots="[
              {slot: 'singleline', title:'Single Line'},
              {slot: 'multiline', title:'Multi Line'},
              {slot: 'number', title:'Number'}
           ]">
          <template v-slot:singleline.button>
            <EditButton
              @edit="onEdit('Single Line')"
              @save="onSave('Single Line')"
              @discard="onDiscard('Single Line')"
            />
          </template>
          <template v-slot:singleline>
            <v-row v-for="n in 2" :key="n">
              <v-col cols="12">
                <TextFieldCustom>
                  <template v-slot:prepend>
                    Einzeiliges Formular-Feld {{ n }}
                  </template>
                </TextFieldCustom>
              </v-col>
            </v-row>
          </template>
          <template v-slot:multiline.button>
            <EditButton
              @edit="onEdit('Multi Line')"
              @save="onSave('Multi Line')"
              @discard="onDiscard('Multi Line')"
            />
          </template>
          <template v-slot:multiline>
            <v-row v-for="n in 2" :key="n + 2">
              <v-col cols="12">
                <TextAreaCustom>
                  <template v-slot:prepend>Mehrzeiliges Formular-Feld {{ n }}</template>
                </TextAreaCustom>
              </v-col>
            </v-row>
          </template>
          <template v-slot:number.button>
            <EditButton
              @edit="onEdit('Number')"
              @save="onSave('Number')"
              @discard="onDiscard('Number')"
            />
          </template>
          <template v-slot:number>
            <v-row>
              <v-col cols="12">
                <NumberTextField v-model="numberTExtFieldModel">
                  <template v-slot:prepend>Number Textfield</template>
                </NumberTextField>
              </v-col>
            </v-row>
          </template>
        </CollapsibleComponent>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
      </v-col>
      <v-col cols="6">
        <CollapsibleComponent
          @edit="onEdit" @save="onSave" @discard="onDiscard"
          :slots="[{slot: 'singleline', title:'Single Line'}]"
        >
          <template v-slot:singleline.button>
            <ButtonPrimaryAction @click.stop/>
          </template>
          <template v-slot:singleline>
            <v-row v-for="n in 2" :key="n">
              <v-col cols="12">
                <TextFieldCustom>
                  <template v-slot:prepend>
                    Einzeiliges Formular-Feld {{ n }}
                  </template>
                </TextFieldCustom>
              </v-col>
            </v-row>
          </template>
        </CollapsibleComponent>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CollapsibleComponent from "@/components/profile/CollapsibleComponent";
import TextFieldCustom from "@/components/form/TextFieldCustom";
import TextAreaCustom from "@/components/form/TextAreaCustom";
import NumberTextField from "@/components/form/NumberTextField";
import {ref} from "@vue/composition-api";
import EditButton from "@/components/buttons/EditButton";
import ButtonPrimaryAction from "@/components/buttons/ButtonPrimaryAction";

export default {
  name: "CollapsibleView",
  components: {
    ButtonPrimaryAction,
    EditButton,
    NumberTextField,
    TextAreaCustom,
    TextFieldCustom,
    CollapsibleComponent
  },
  setup() {

    function onEdit(slotTitle) {
      console.log('edit event on slot ' + slotTitle)
    }

    function onSave(slotTitle) {
      console.log('save event on slot ' + slotTitle)
    }

    function onDiscard(slotTitle) {
      console.log('discard event on slot ' + slotTitle)
    }

    const numberTExtFieldModel = ref('')
    return {onEdit, onSave, onDiscard, numberTExtFieldModel}
  }
}
</script>

<style scoped>

</style>
